import {
  SPACE_TYPE_CHANNEL,
  SPACE_TYPE_GROUP,
  SPACE_TYPE_TEAM,
} from "@qihoo/tuitui-bot-sdk";
import { CHANNEL_ID } from "./const";
import {CHAT_TYPE_CHANNEL, parseSessionKey} from "./chat_base"
import { createTuituiClient } from "./sdk";

export { SPACE_TYPE_CHANNEL, SPACE_TYPE_GROUP, SPACE_TYPE_TEAM };

export async function file_space_list(
  account: any,
  sessionKey: string
): Promise<any> {

  const session_info = parseSessionKey(sessionKey);
  if(session_info.chat_type != CHAT_TYPE_CHANNEL) {
    throw new Error(`私聊、群聊会话不支持共享空间。仅团队频道支持。`);
  }

  const flat_list = await createTuituiClient(account).fileSpace.listTeamFilesByChannel(session_info.channel_id);

  console.log(`[${CHANNEL_ID}] file_space_list `, flat_list);
  return flat_list
}

export async function file_space_add(
  account: any,
  sessionKey: string,
  cloud_filepath: string,
  url_or_localpath: string,
): Promise<any> {
  const session_info = parseSessionKey(sessionKey);
  if(session_info.chat_type != CHAT_TYPE_CHANNEL) {
    throw new Error(`私聊、群聊会话不支持共享空间。仅团队频道支持。`);
  }

  const source = session_info.thread_id;

  // 1. 解析云路径，分离目录和文件名
  const normalizedPath = cloud_filepath.startsWith('/')
    ? cloud_filepath
    : '/' + cloud_filepath;

  console.log(`[${CHANNEL_ID}] file_space_add: uploading ${normalizedPath}`);
  const body = await createTuituiClient(account).fileSpace.addTeamFileByChannel(
    session_info.channel_id,
    normalizedPath,
    url_or_localpath,
    { sourcePostId: source },
  );
  console.log(`[${CHANNEL_ID}] file_space_add: uploaded ${normalizedPath}`, body);
  return `success uploaded to ${normalizedPath}`;
}
